export default __webpack_public_path__ + "static/james-ownby-neat-thumbnail-8d40a2a59df855ffeb3f13ddc783e5f6.jpg";